import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Grid,
  CircularProgress,
  Box,
} from "@mui/material";

const API_BASE = "https://appapi.unpaidfinancial.com/api"; // change selon ton backend

function AnnulerDemandes() {
  const [demandes, setDemandes] = useState([]);
  const [loading, setLoading] = useState(true);

  // Récupérer toutes les demandes à statut attente_annulation
  const fetchDemandes = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE}/demandes`, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
      });
      // Filtrer seulement celles en attente d'annulation
      const enAttenteAnnulation = res.data.filter(
        (d) => d.statut === "attente_annulation"
      );
      setDemandes(enAttenteAnnulation);
    } catch (e) {
      alert("Erreur de chargement des demandes.");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDemandes();
    // eslint-disable-next-line
  }, []);

  // Action valider (passe à 'annulé' => supprimé)
  const handleValider = async (id) => {
    if (!window.confirm("Confirmer l'annulation de cette demande ?")) return;
    try {
      await axios.put(
        `${API_BASE}/admin/demandes/${id}/status`,
        { statut: "annulé" },
        {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
        }
      );
      setDemandes(demandes.filter((d) => d.id !== id));
    } catch (e) {
      alert("Erreur lors de la validation.");
    }
  };

  // Action rejeter (passe à en_attente)
  const handleRejeter = async (id) => {
    if (!window.confirm("Confirmer le rejet de la demande d'annulation ?")) return;
    try {
      await axios.put(
        `${API_BASE}/admin/demandes/${id}/status`,
        { statut: "en_attente" },
        {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
        }
      );
      setDemandes(demandes.filter((d) => d.id !== id));
    } catch (e) {
      alert("Erreur lors du rejet.");
    }
  };

  if (loading) {
    return (
      <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 3 }} style={{marginLeft:'10px'}}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>
        Demandes d’annulation à traiter
      </Typography>
      <Grid container spacing={2}>
        {demandes.length === 0 && (
          <Grid item xs={12}>
            <Typography>Aucune demande d’annulation en cours.</Typography>
          </Grid>
        )}
        {demandes.map((demande) => (
          <Grid item xs={12} md={6} lg={4} key={demande.id}>
            <Card elevation={3} sx={{ borderRadius: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  {demande.prenom} {demande.nom}
                </Typography>
                <Typography>Email : {demande.email}</Typography>
                <Typography>Montant demandé : {demande.montantDemande} {demande.devise}</Typography>
                <Typography>Projet : {demande.projetDescription}</Typography>
                <Typography>Ville : {demande.ville}</Typography>
                <Typography>Pays : {demande.pays}</Typography>
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => handleValider(demande.id)}
                >
                  Valider
                </Button>
                <Button
                  variant="outlined"
                  color="warning"
                  onClick={() => handleRejeter(demande.id)}
                >
                  Rejeter
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default AnnulerDemandes;
